var filterByDelivery = function filterByDelivery(obj) {
  if ('slug' in obj && obj.slug === 'delivery_magalu') {
    return true;
  }
  return false;
};
export default filterByDelivery;